export function parsePageParam(raw: string | null): number {
  const parsed = Number.parseInt(raw ?? '', 10)
  return Number.isNaN(parsed) || parsed < 1 ? 1 : parsed
}

export function pageCount(total: number, pageSize: number): number {
  if (!Number.isFinite(total) || total <= 0 || pageSize <= 0) return 1
  return Math.max(1, Math.ceil(total / pageSize))
}
